import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import RenderLoader from './components/RenderLoader'
import Privacy from "./screens/Privacy";
import PackageScreen from "./screens/PackageScreen";
import { seoContentPaths } from "./data/seoContentPaths";
import { trackPageView } from "./utils/analytics";
const CheckoutScreen = lazy(() => import('./screens/CheckoutScreen'))
const GuestHomeScreen = lazy(() => import('./screens/GuestHomeScreen'))
const ProductScreen = lazy(() => import('./screens/ProductScreen'))
const CartScreen = lazy(() => import('./screens/CartScreen'))
const OrderCompleted = lazy(() => import('./screens/OrderCompleted'))
const LandingPage = lazy(() => import('./screens/LandingPage'))
const SeoPage = lazy(() => import('./screens/SeoPage'))
const SeoContentPage = lazy(() => import('./screens/SeoContentPage'))
const Guest = lazy(() => import('./screens/Guest'))
const GuestAddOn = lazy(() => import('./screens/GuestAddOn.js'))
const SavedCartGuest = lazy(() => import('./screens/SavedCartGuest'))
const OrderDriverImages = lazy(() => import('./components/OrderDriverImages'));
const PageNotFoundScreen = lazy(() => import('./screens/PageNotFoundScreen'));
const SMSCompliance = lazy(() => import('./screens/SMSCompliance'))
const OrderTracking = lazy(() => import('./screens/OrderTracking'))
const LuxeStoryShell = lazy(() => import('./screens/luxe/LuxeStoryShell'))

const TermsAndConditions = lazy(() => import('./screens/TermsAndConditions'))

const withLoader = (component) => (
  <Suspense fallback={<RenderLoader />}>
    {component}
  </Suspense>
);

function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <div>
      <div className="flex w-full min-h-screen">
        <Routes>
          <Route path='/' element={withLoader(<LandingPage />)} />

          <Route path='/vacation-rental-grocery-delivery' element={withLoader(<SeoPage pageKey="vacationRentalGroceryDelivery" />)} />
          <Route path='/fridge-stocking-service' element={withLoader(<SeoPage pageKey="fridgeStockingService" />)} />
          <Route path='/pre-arrival-groceries' element={withLoader(<SeoPage pageKey="preArrivalGroceries" />)} />
          <Route path='/airbnb-grocery-delivery' element={withLoader(<SeoPage pageKey="airbnbGroceryDelivery" />)} />
          <Route path='/airbnb-grocery-stocking' element={withLoader(<SeoPage pageKey="airbnbGroceryStocking" />)} />
          <Route path='/short-term-rental-concierge-services' element={withLoader(<SeoPage pageKey="shortTermRentalConciergeServices" />)} />
          <Route path='/for/property-managers' element={withLoader(<SeoPage pageKey="propertyManagers" />)} />
          <Route path='/integrations' element={withLoader(<SeoPage pageKey="integrations" />)} />
          <Route path='/integrations/:integration' element={withLoader(<SeoPage pageKey="integration" />)} />
          <Route path='/locations/:city/airbnb-grocery-delivery' element={withLoader(<SeoPage pageKey="location" />)} />
          {seoContentPaths.map((path) => (
            <Route key={path} path={path.replace(/\/$/, '')} element={withLoader(<SeoContentPage />)} />
          ))}

          {/* Unlisted presentation: not in sitemap, noindex via Helmet in the shell */}
          {/* <Route path='/airbnb-luxe' element={withLoader(<LuxeStoryShell />)} /> */}

          <Route path='/homeproducts' element={withLoader(<GuestHomeScreen />)} />
          <Route path='/guest/r/:cid' element={withLoader(<Guest />)} />
          <Route path='/guest/:pid' element={withLoader(<Guest />)} />
          <Route path='/product/:id' element={withLoader(<ProductScreen />)} />
          <Route path='/cart' element={withLoader(<CartScreen />)} />
          <Route path='/checkout' element={withLoader(<CheckoutScreen />)} />
          <Route path='/orderCompleted' element={withLoader(<OrderCompleted />)} />
          <Route path='/privacy' element={withLoader(<Privacy />)} />
          <Route path='/package/:pid' element={withLoader(<PackageScreen />)} />
          <Route path='/guest' element={withLoader(<Guest />)} />
          <Route path='/the-top-villas' element={withLoader(<Guest />)} />
          <Route path='/guest/:pid/ebikes' element={withLoader(<Guest />)} />
          <Route path='/order/:oid' element={withLoader(<OrderDriverImages />)} />
          <Route path='/sms' element={withLoader(<SMSCompliance />)} />
          <Route path='/terms' element={withLoader(<TermsAndConditions />)} />
          <Route path='/order-tracking/:oid' element={withLoader(<OrderTracking />)} />
          <Route path='/guest/:pid/savedcart/:cartCode' element={withLoader(<SavedCartGuest />)} />
          <Route path="/guest/:pid/addon/:orderAddOnCode" element={withLoader(<GuestAddOn />)} />
          <Route path="*" element={withLoader(<PageNotFoundScreen />)} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
